import type { GridPaginationModel, GridRowSelectionModel, GridSortModel } from '@mui/x-data-grid-pro';
import { createContext } from 'react';
import type { FieldValues } from 'react-hook-form';

export type ExplorerServiceAdapterState = {
  paginationModel: GridPaginationModel;
  sortingModel: GridSortModel;
  liveSearch: string;
  activeDrawerFilters: FieldValues;
};

export type ExplorerSelectionConfirmHandler = (model: GridRowSelectionModel) => void | Promise<void>;

export type ExplorerStartSelectionOptions = {
  id?: string;
  maxSelection?: number;
  onConfirm: ExplorerSelectionConfirmHandler;
};

export type ExplorerContextValue = {
  selectionMode: boolean;
  selectionModel: GridRowSelectionModel;
  selectedCount: number;
  totalCount: number;
  maxSelection: number;
  pendingSelectionActionId?: string;
  serviceState: ExplorerServiceAdapterState;
  startSelection: (options: ExplorerStartSelectionOptions) => void;
  confirmSelection: () => void;
  cancelSelection: () => void;
  clearSelection: () => void;
  setSelectionModel: (model: GridRowSelectionModel) => void;
};

export const ExplorerContext = createContext<ExplorerContextValue | null>(null);
